<!-- <div class="layout-topbar" style="z-index: 99999;"> -->
<div class="layout-topbar">
  <a class="layout-topbar-logo" style="width: auto" routerLink="/" aria-label="Tools home">
    <img src="assets/images/GLOS_LOGO.png" alt="Convatec Tools Logo" style="height: 3.9rem; width: 10rem" />
  </a>

  <button
    #menubutton
    class="p-link layout-menu-button layout-topbar-button"
    (click)="layoutService.onMenuToggle()"
    pTooltip="Toggle sidebar"
    aria-label="Toggle sidebar"
  >
    <i class="pi pi-bars"></i>
  </button>
  <!-- <button
    #menubutton
    class="nav-btn p-link layout-menu-button layout-topbar-button"
    pTooltip="Go to TMS"
    [routerLink]="['/customer-services-menu']"
  >
    <i class="fas fa-truck-plane text-red-500"></i>
  </button> -->
  <!-- <button
    #menubutton
    class="nav-btn p-link layout-menu-button layout-topbar-button"
    pTooltip="Go to Warehouse"
    [routerLink]="['/warehouse-menu']"
  >
    <i class="fas fa-warehouse text-green-500"></i>
  </button> -->
  <!-- <button
    #menubutton
    class="nav-btn p-link layout-menu-button layout-topbar-button"
    pTooltip="Go to External Data"
    [routerLink]="['/external-data-menu']"
  >
    <i class="pi pi-table text-grey-500"></i>
  </button> -->
  <!-- <button
    #menubutton
    class="nav-btn p-link layout-menu-button layout-topbar-button"
    pTooltip="Go to Inventory"
    [routerLink]="['/inventory']"
  >
    <i class="pi icon-inventory text-yellow-500"></i>
  </button> -->

  <button
    #topbarmenubutton
    class="p-link layout-topbar-menu-button layout-topbar-button"
    (click)="layoutService.showProfileSidebar()"
  >
    <i class="pi pi-ellipsis-v"></i>
  </button>
  <!-- <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button" (click)="onConfigButtonClick()">
        <i class="pi pi-cog"></i>
    </button> -->

  <div
    #topbarmenu
    class="layout-topbar-menu"
    [ngClass]="{
      'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible
    }"
  >
    <!-- <button class="p-link layout-topbar-button">
            <i class="pi pi-calendar"></i>
            <span>Calendar</span>
        </button> -->

    <!-- <p-avatar
      class="flex align-items-center"
      [image]="userImage"
      shape="circle"
      *ngIf="userImage"
    ></p-avatar>
    <p-avatar
      class="flex align-items-center"
      shape="circle"
      icon="pi pi-user"
      *ngIf="!userImage"
    ></p-avatar> -->

    <!-- <button
      class="p-link layout-topbar-button"
      (click)="onConfigButtonClick()"
      pTooltip="Theme Menu"
    >
      <i class="pi pi-cog"></i>
      <span>Theme Menu</span>
    </button> -->

    <button
      class="p-link layout-topbar-button"
      [routerLink]="['/auth/login']"
      pTooltip="Logout"
      tooltipPosition="left"
    >
      <i class="pi pi-power-off"></i>
      <span>Log out</span>
    </button>
    <!-- <button class="p-link layout-topbar-button" [routerLink]="'/documentation'">
            <i class="pi pi-cog"></i>
            <span>Settings</span>
        </button> -->
  </div>
</div>
